import { useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";

const SECTION = 'applicant_income';

const CompareWorkIncomeSection = () => {
  const {
    showOnlyDiff,
    hasDiff,
    shouldShow,
    ownApplicantData,
    otherApplicantData,
    handleApplicantDataChange,
    workIncomeFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleDataChange = (e) => {
    handleApplicantDataChange(e, SECTION);
  };

  if (
    showOnlyDiff &&
    !hasSectionCopiedFields(SECTION) &&
    !hasDiff(workIncomeFields, ownApplicantData, otherApplicantData)
  )
    return null;

  return (
    <Stack space="l">
      <CategoryHeader>
        <span>{t('Werk & Inkomen')}</span>
        <span>{t('Werk & Inkomen')}</span>
      </CategoryHeader>
      <Stack space="m">
        {shouldShow(
          'gross_yearly_income',
          ownApplicantData,
          otherApplicantData,
          SECTION
        ) && (
          <Compare
            label={t("Jaarinkomen")}
            name="gross_yearly_income"
            section={SECTION}
            leftValue={ownApplicantData?.gross_yearly_income}
            rightValue={otherApplicantData?.gross_yearly_income}
            onUpdate={handleDataChange}
            isCurrency
          />
        )}
        {shouldShow(
          'pension_income',
          ownApplicantData,
          otherApplicantData,
          SECTION
        ) && (
          <Compare
            label={t("Jaarinkomen vanaf AOW-datum")}
            name="pension_income"
            section={SECTION}
            leftValue={ownApplicantData?.pension_income}
            rightValue={otherApplicantData?.pension_income}
            onUpdate={handleDataChange}
            isCurrency
          />
        )}
      </Stack>
    </Stack>
  );
};

export default CompareWorkIncomeSection;
